import { createAsyncThunk } from "@reduxjs/toolkit";
import API from "../../../utils/api";



//credential-list
export const credentialList = createAsyncThunk(
  "credential-list",
  async (bodyParams, thunkAPI) => {
    try {
      const response = await API.get(`/credentials`, { params: bodyParams });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

//credential-view
export const credentialView = createAsyncThunk(
  "credential-view",
  async (bodyParams, thunkAPI) => {
    try {
      const response = await API.get(`credential/${bodyParams}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

//credential-create
export const credentialCreate = createAsyncThunk(
  "credential-create",
  async (bodyParams, thunkAPI) => {
    try {
      const response = await API.postForm(`credential`, bodyParams);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

//credential-update
export const credentialUpdate = createAsyncThunk(
  'credential-update',
  async (bodyParams, thunkAPI) => {
    try {
       const response = await API.postForm(`/credential/${bodyParams.id}`, bodyParams.formData);
      return response
    }
    catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  })


// credential-delete
export const credentialDelete = createAsyncThunk(
  "credential-delete",
  async (bodyParams, thunkAPI) => {
    try {
      const response = await API.delete(`credential/${bodyParams.id}`);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);


//credential-category-create
export const credentialCategoryCreate = createAsyncThunk(
  "credential-category-create",
  async (bodyParams, thunkAPI) => {
    try {
      const response = await API.post(`/credential-category`, bodyParams);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

//credential document delete
export const CredentialImageDocUploadDelete = createAsyncThunk(
  "credential-document-delete",
  async (bodyParams, thunkAPI) => {
    try {
      const response = await API.delete(
        `/credentials/${bodyParams.credentialId}/documents/${bodyParams.id}`,
        bodyParams,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);


//credential-otp-send
export const credentialCreateOtp = createAsyncThunk(
  "credential-otp-create",
  async (bodyParams, thunkAPI) => {
    try {
      const response = await API.postForm(`credential-otp`, bodyParams);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

//credential-otp-verify
export const credentialVerifyOtp = createAsyncThunk(
  "credential-otp-verify",
  async (bodyParams, thunkAPI) => {
    try {
      const response = await API.postForm(`credential-otp-verify`, bodyParams);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);